import { Group, Select, TextInput } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import React, { FormEvent } from "react";

import { WelcomeFormValues } from "features/user/types";

type CreateOrgFormProps = {
  form: UseFormReturnType<WelcomeFormValues>;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
};

function CreateOrgForm({ form, handleSubmit }: CreateOrgFormProps) {
  return (
    <form id="create-org-form" onSubmit={handleSubmit}>
      <TextInput
        label="Organization"
        placeholder="Atlassian"
        {...form.getInputProps("organization")}
        size="md"
        mb={15}
      />
      <TextInput
        label="Position"
        placeholder="Software Engineer"
        {...form.getInputProps("position")}
        size="md"
        mb={15}
      />
      <Select
        label="Role"
        description="Only 'Admin' is allowed"
        readOnly
        disabled
        data={[{ value: "admin", label: "Admin" }]}
        {...form.getInputProps("role")}
        size="md"
        inputWrapperOrder={["label", "input", "description", "error"]}
      />
      <Group grow mb={15}>
        <TextInput
          label="Fiscal Year Start Date"
          placeholder="YYYY-MM-DD"
          type="date"
          {...form.getInputProps("fiscalYearStartDate")}
          size="md"
        />

        <TextInput
          label="Fiscal Year End Date"
          placeholder="YYYY-MM-DD"
          type="date"
          {...form.getInputProps("fiscalYearEndDate")}
          size="md"
        />
      </Group>
    </form>
  );
}

export default CreateOrgForm;
